import { Form, Button, Col, Row, Alert, Table, Spinner } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { SpinnerModal, generateYears, getFiscalYear } from '../report/Util';

import axios from "axios";
import { Link } from "react-router-dom";
import { FaSpinner } from 'react-icons/fa';
import { Chart } from 'react-google-charts';
import { useNavigate } from 'react-router-dom';
const ViewSearch = ({ url, pagePath }) => {
    const navigate = useNavigate();

    const years = generateYears(2020, new Date().getFullYear());
    const data = {
        siteName: "",
        year: "",
        month: "",
        status: ""
    }

    const [formData, setFormData] = useState(data);
    const [responseData, setResponseData] = useState([]);
    const [spinner, setSpinner] = useState(false);
    const [userName, setUserName] = useState(null);
    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        console.log(`storedUser: ${storedUser}`);
        if (storedUser) {
            const { firstName, lastName } = JSON.parse(storedUser);
            setUserName(`${firstName} ${lastName}`.toUpperCase());
        }
    }, []);
    useEffect(() => {
        console.log(url);

        setSpinner(true);
        axios.post(url, formData)
            .then(response => {
                setSpinner(false);
                setResponseData(response.data);
                console.log(responseData);
            })
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const [group, ...keys] = name.split('.');
        if (keys.length >= 1) {
            const updatedFormData = { ...formData };
            let currentLevel = updatedFormData[group];
            keys.forEach((key, index) => {
                if (index === keys.length - 1) {
                    currentLevel[key] = value;
                } else {
                    currentLevel[key] = { ...currentLevel[key] };
                    currentLevel = currentLevel[key];
                }

            });
            setFormData(updatedFormData);
        } else {
            setFormData({ ...formData, [name]: value });

        }

    };
    const handleReset = (e) => {
        setFormData(data);
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(`url:${url},formData:${formData}`);
        axios.post(url, formData)
            .then(response => {
                setSpinner(false);
                setResponseData(response.data);
                console.log(responseData);
            })


    }


    const tableData = responseData.map(item => [
        (item.status === 'DRAFT') ?
            `<a href=${pagePath}/${item._id}>${item.siteName}</a>` :
            `<a href=${pagePath}Response}/${item._id}>${item.siteName}</a>`,
        //navigate(`${pagePath}Response/${item._id}`),
        // (<Link to={`${pagePath}Response/${item._id}`}>{item.siteName}</Link>),
        //Link(`${pagePath}Response/${item._id}`),
        //React.createElement(Link, { to: `${pagePath}Response/${item._id}`}, '${item.siteName}'),
        //Link ('<a ${pagePath}Response/${item._id}>${item.siteName}</a>'),
        item.year, item.month, item.status, item.type, item.createdBy, item.createdDate]);


    const viewData = [['SiteName', 'Year', 'Month', 'Status', 'ReportType', 'Submitted By', 'Submitted Date'], ...tableData]
    const viewDataOptions = {
        allowHtml: true,
        showRowNumber: true,
        pageSize: 20,
    }

    const viewDataFormatters = [
        {
            // type: "PatternFormat",
            // column: 0,
            // options: '<a href="{0}">{0}</a>',
        },
    ];
    return (
        <>

            <div className="main-content">
                <Form className="main-content" onSubmit={handleSubmit} >
                    <Row className="mb-0 main-content">

                        <Form.Group as={Col} controlId="sitename" >
                            <Form.Label>SiteName</Form.Label>
                            <Form.Select defaultValue="" name="siteName" value={formData.siteName} onChange={handleInputChange}>
                                <option value="">Select</option>
                                <option>ANTHRACITE HERITAGE</option>
                                <option>BRANDYWINE BATTLEFIELD</option>
                                <option>BUSHY </option>
                                <option>CONRAD W</option>
                                <option>CORNWALL</option>
                                <option>DANIEL B</option>
                                <option>DRAKE WELL</option>
                                <option>ECKLEY MINERS' VLGE</option>
                                <option>EPHRATA CLOISTER</option>
                                <option>ERIE MARITIME</option>
                                <option>FORT PITT</option>
                                <option>GRAEME </option>
                                <option>HOPE</option>
                                <option>JOSEPH P</option>
                                <option>LANDIS VALLEY</option>
                                <option>OLD ECONOMY</option>
                                <option>PENNSBURY</option>
                                <option>PA LUMBER MUSEUM</option>
                                <option>PA MILITARY MUSEUM</option>
                                <option>RAILROAD MUSEUM</option>
                                <option>SOMERSET</option>
                            </Form.Select>

                        </Form.Group>

                        <Form.Group as={Col} controlId="year">
                            <Form.Label>Year</Form.Label>
                            <Form.Select defaultValue="" name="year" value={formData.year} onChange={handleInputChange}>
                                <option value="">Select</option>
                                {years.map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} controlId="month">
                            <Form.Label>Month</Form.Label>
                            <Form.Select defaultValue="" name="month" value={formData.month} onChange={handleInputChange}>
                                <option value="">Select</option>
                                <option>JANUARY</option>
                                <option>FEBRAURY</option>
                                <option>MARCH</option>
                                <option>APRIL</option>
                                <option>MAY</option>
                                <option>JUNE</option>
                                <option>JULY</option>
                                <option>AUGUST</option>
                                <option>SEPTEMBER</option>
                                <option>OCTOBER</option>
                                <option>NOVEMBER</option>
                                <option>DECEMBER</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} controlId="status">
                            <Form.Label>Status</Form.Label>
                            <Form.Select defaultValue="" name="status" value={formData.status} onChange={handleInputChange}>
                                <option value="">Select</option>
                                <option>DRAFT</option>
                                <option>SUBMITTED</option>
                                <option>APPROVED</option>
                                <option>REJECTED</option>
                            </Form.Select>
                        </Form.Group>
                    </Row>

                    <Row className="mb-3 main-content">
                        <Col>
                            <Row className="mb-3 main-content">
                                <Col>
                                    <Button variant="secondary" name="reset" onClick={handleReset}>
                                        Reset
                                    </Button>
                                </Col><Col>
                                    <Button variant="primary" type="submit" name="submit">
                                        Search
                                    </Button>
                                </Col>
                                <Col /></Row>
                        </Col>
                        <Col />

                        <Col />
                        <Col />
                        <Col />
                    </Row>
                </Form>
                {spinner && (<Spinner />)}
                {/*
                    <Chart
                        width={'100%'}
                        height={'100%'}
                        chartType="Table"
                        loader={<div>Loading Chart</div>}
                        data={viewData}
                        options={viewDataOptions}
                        formatters={viewDataFormatters}

                    />
                                */}
                {<Table striped bordered hover variant="light" responsive="md">
                    <thead>
                        <tr>
                            <th>Site Name</th>
                            <th>Year</th>
                            <th>Month</th>
                            <th>Report Type</th>
                            <th>Status</th>
                            <th>SubmittedBy</th>
                            <th>SubmittedDate</th>
                        </tr>
                    </thead>
                    <tbody>
                        {spinner && (<Spinner />)}

                        {
                            responseData.length !== 0 ? (
                                responseData.map(d => (

                                    <tr>
                                        <td>
                                            {d.status === 'DRAFT' || (d.status === 'REJECTED' && d.createdBy === userName) ?
                                                <Link to={{ pathname: `${pagePath}/${d._id}` }}>{d.siteName}</Link>
                                                :
                                                <Link to={{ pathname: `${pagePath}Response/${d._id}` }}>{d.siteName}</Link>
                                            }
                                        </td>
                                        <td>{d.year}</td>
                                        <td>{d.month}</td>
                                        <td>{d.type}</td>
                                        <td>{d.status} </td>
                                        <td>{d.createdBy}</td>
                                        <td>{d.updatedDate}</td>
                                    </tr>
                                ))) : (<tr><td colSpan={7}>No records found!</td></tr>)

                        }


                    </tbody>
                </Table>}
            </div >
        </>
    );
}

export default ViewSearch;